/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactExport from 'react-export-excel';
import { useTranslation } from 'react-i18next';
import c from '../../../constant';
import { fileNameEWS } from '../Miscellaneous/export';
import useStore from '../../../store';
import { getYear } from '../../../containers/EarlyWarning/utils';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcelSummarizedReportSFP({ month = null, year = null, object = null, ...props }) {
	const { t } = useTranslation();
	const { currentLang } = useStore((state) => state.currentLang);

	return (
		<Box {...props}>
			<ExcelFile
				filename={fileNameEWS(`SFP Summarized Report ${getYear(year)}`, month, year)}
				element={
					<Button
						isLoading={false}
						isDisabled={false}
						onClick={() => null}
						leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
						colorScheme="gray"
						variant="solid"
						size="sm"
						borderRadius={c.borderRadius}
						border="1px solid #bdc3c7"
					>
						{t('Export')}
					</Button>
				}
			>
				{(Array.isArray(object) ? object : [object])?.map((object, i) => {
					if (!object?.labels?.length) return null;

					const data = object?.labels?.map((label, j) => ({
						title: currentLang === 'kh' ? label?.titleKhmer : label?.titleEnglish,
						valueUSD_q1: object.q1Cells?.[j]?.[0]?.value || '',
						valueKHR_q1: object.q1Cells?.[j]?.[1]?.value || '',
						valueUSD_q2: object.q2Cells?.[j]?.[0]?.value || '',
						valueKHR_q2: object.q2Cells?.[j]?.[1]?.value || '',
						valueUSD_q3: object.q3Cells?.[j]?.[0]?.value || '',
						valueKHR_q3: object.q3Cells?.[j]?.[1]?.value || '',
						valueUSD_q4: object.q4Cells?.[j]?.[0]?.value || '',
						valueKHR_q4: object.q4Cells?.[j]?.[1]?.value || '',
					}));

					return (
						<ExcelSheet key={i} data={data} name={object?.code || `Sheet ${i + 1}`}>
							<ExcelColumn label={t('Label')} value="title" />
							<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ១_ដុល្លារ​អាមេរិក' : 'Q1_USD'} value="valueUSD_q1" />
							<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ១_ពាន់រៀល' : `Q1_KHR'000`} value="valueKHR_q1" />
							<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ២_ដុល្លារ​អាមេរិក' : 'Q2_USD'} value="valueUSD_q2" />
							<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ២_ពាន់រៀល' : `Q2_KHR'000`} value="valueKHR_q2" />
							<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ៣_ដុល្លារ​អាមេរិក' : 'Q3_USD'} value="valueUSD_q3" />
							<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ៣_ពាន់រៀល' : `Q3_KHR'000`} value="valueKHR_q3" />
							<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ៤_ដុល្លារ​អាមេរិក' : 'Q4_USD'} value="valueUSD_q4" />
							<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ៤_ពាន់រៀល' : `Q4_KHR'000`} value="valueKHR_q4" />
						</ExcelSheet>
					);
				})}
			</ExcelFile>
		</Box>
	);
}
